@if (invalidFormControls.length > 0) {
  <div
    class="alert alert-danger"
    role="group"
    [attr.aria-labelledby]="componentId + '-header'"
    tabindex="-1"
    id="{{ componentId }}"
  >
    <h2
      [ngClass]="invalidFormControls.length > 3 ? 'visuallyhidden' : ''"
      id="{{ componentId }}-header"
      [innerHTML]="header"
    ></h2>
    @if (invalidFormControls.length > 3) {
      <ul>
        @for (error of formErrorsWithNames; track error) {
          <li>
            <a [routerLink]="[]" fragment="{{ error.controlName }}" href="" (click)="navigateToFormControl($event)">{{
              error.controlText
            }}</a>
            -
            {{ error.message }}
          </li>
        }
      </ul>
    }
    @if (invalidFormControls.length <= 3) {
      <p>{{ 'form_validation_errors' | translate }}</p>
    }
  </div>
}
